const levelPrices = [200, 400, 800, 1600, 3200, 6400, 12800, 25000, 50000, 100000, 200000, 400000, 800000, 1500000, 3000000];

export default levelPrices;